import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ContentTypes, ZoneId } from '@nibtravel/shared/data-access/contentful';
import { Features } from '@nibtravel/shared/util/feature-toggle';

@Component({
  selector: 'nibtravel-travel-alert',
  templateUrl: './travel-alert.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TravelAlertComponent {
  ContentTypes = ContentTypes;
  Features = Features;

  @Input() zone = ZoneId.TravelAlertBanner;
}
